(() => {
  const confirmationCheckbox = '#camping_subscription_withdrawal_form_cancel_camping_reservation_confirmation';
  const cancelPolicyCheckbox = '#camping_subscription_withdrawal_form_cancel_policy_confirmation';
  const init = () => {

    $('.camping-subscription-withdrawal-active-button').hide();
    $('.disabled-button-itself').prop('disabled', true);
    $('body').on('click', { confirmationCheckbox, cancelPolicyCheckbox }, showActiveButton);

  }

  const showActiveButton = () => {
    if ($(confirmationCheckbox).prop('checked') && $(cancelPolicyCheckbox).prop('checked'))  {
      $('.camping-subscription-withdrawal-active-button').show();
      $('.camping-subscription-withdrawal-disabled-button').hide();
    }
  }
  $(init);
})();

